/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useGLTF, Billboard, Text } from "@react-three/drei";
import HoverText from "./HoverText";
import Character from "./character";

const data = {
  position: [0, 23, -15],
  islandName: "About Me",
};

export default function Model({ ...props }) {
  const [visible, setVisible] = useState(false);
  const [play, setPlay] = useState(false);

  const group = useRef();
  const { nodes, materials } = useGLTF("../../../AboutMeIsland.glb");

  return (
    <>
      <Character play={play} />
      <HoverText visible={visible} fontProps={props.fontProps} data={data} />
      <group
        ref={group}
        {...props}
        dispose={null}
        onPointerEnter={() => {
          props.hoverIslandEnter("AboutMeIsland");
          setVisible(true);
          setPlay(true);
        }}
        onPointerLeave={() => {
          props.hoverIslandExit("AboutMeIsland");
          setVisible(false);
          setPlay(false);
        }}
        onClick={() => props.setOpen(true)}
      >
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-grass"].geometry}
          material={materials["minecraft_block-grass"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-furnace_side"].geometry}
          material={materials["minecraft_block-furnace_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_block-crafting_table_front002"].geometry}
          material={materials["minecraft_block-crafting_table_front"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-bricks"].geometry}
          material={materials["minecraft_block-bricks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-dirt"].geometry}
          material={materials["minecraft_block-dirt"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          castShadow
          geometry={nodes["minecraft_block-glass"].geometry}
          material={materials["minecraft_block-glass"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-tall_grass_top"].geometry}
          material={materials["minecraft_block-tall_grass_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-oak_planks"].geometry}
          material={materials["minecraft_block-oak_planks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_block-furnace_front"].geometry}
          material={materials["minecraft_block-furnace_front"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_block-furnace_top"].geometry}
          material={materials["minecraft_block-furnace_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_entity-bed-white"].geometry}
          material={materials["minecraft_entity-bed-white"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-oak_log"].geometry}
          material={materials["minecraft_block-oak_log"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-lantern"].geometry}
          material={materials["minecraft_block-lantern"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_block-crafting_table_top002"].geometry}
          material={materials["minecraft_block-crafting_table_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          castShadow
          geometry={nodes["minecraft_block-peony_bottom"].geometry}
          material={materials["minecraft_block-peony_bottom"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_block-cobweb"].geometry}
          material={materials["minecraft_block-cobweb"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-spruce_door_bottom"].geometry}
          material={materials["minecraft_block-spruce_door_bottom"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-dark_oak_planks"].geometry}
          material={materials["minecraft_block-dark_oak_planks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-spruce_trapdoor002"].geometry}
          material={materials["minecraft_block-spruce_trapdoor"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          geometry={nodes["minecraft_block-grass_block_side"].geometry}
          material={materials["minecraft_block-grass_block_side"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-dandelion"].geometry}
          material={materials["minecraft_block-dandelion"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-tall_grass_bottom"].geometry}
          material={materials["minecraft_block-tall_grass_bottom"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-peony_top"].geometry}
          material={materials["minecraft_block-peony_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-oak_log_top"].geometry}
          material={materials["minecraft_block-oak_log_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-oxeye_daisy"].geometry}
          material={materials["minecraft_block-oxeye_daisy"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-grass_block_top"].geometry}
          material={materials["minecraft_block-grass_block_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-spruce_door_top"].geometry}
          material={materials["minecraft_block-spruce_door_top"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          geometry={nodes["minecraft_block-stone_bricks003"].geometry}
          material={materials["minecraft_block-stone_bricks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-cobblestone"].geometry}
          material={materials["minecraft_block-cobblestone"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes["minecraft_block-spruce_planks002"].geometry}
          material={materials["minecraft_block-spruce_planks"]}
          position={[70, 55, -35.72]}
          rotation={[Math.PI / 2, 0, 0]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.stone_bricks.geometry}
          material={materials.stone_bricks_north}
          position={[2, 11.49, -9.75]}
        />
        <mesh
          receiveShadow
          castShadow
          geometry={nodes.stone_bricks001.geometry}
          material={materials.stone_bricks_north}
          position={[-2, 11.49, -9.75]}
        />
      </group>
    </>
  );
}

useGLTF.preload("../../../AboutMeIsland.glb");
